import React from "react";
import { LikeOutlined } from "@ant-design/icons";
import { formatVideoDuration, formatThousend } from "../../../utils/helper";
import LazyloadImage from "@Components/newNav/lazyLoadImage";
export interface IProps {
  data: {
    [key: string]: any;
  };
  imgBoxCss: string;
  urlParams?: string;
  clickOpenNewPage?: boolean;
  onClick?: () => void;
  isMount?: boolean;
  height?: string;
}

const MoviesShort: React.FC<IProps> = (props: IProps) => {
  const { height = "100%", data, urlParams, clickOpenNewPage = true, imgBoxCss, onClick, isMount = true } = props;

  return (
    <section className='w-full'>
      <a
        data-id={data.id}
        href={`${data.link || data.shareLink}${urlParams || ""}`}
        target={`${clickOpenNewPage ? "_blank" : "_self"}`}
        className='MoviesShortItem inline-block w-full'
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
      >
        <div className={`rounded-tl-8 rounded-tr-8 flex bg-[#000] items-center relative overflow-hidden ${imgBoxCss}`}>
          <LazyloadImage
            src={data.thumb}
            alt=''
            style={{ width: "100%", height: height, objectFit: "cover" }}
            Loaded={isMount}
          />
          {!!formatVideoDuration(data?.playTime) && (
            <span className='px-10 bg-black bg-opacity-50 rounded-tl-8 text-white font-semibold leading-20 absolute bottom-0 right-0'>
              {formatVideoDuration(data.playTime)}
            </span>
          )}
          <LazyloadImage
            src='https://photo.8891.com.tw/2023/10/09/1696843896847944.png'
            style={{
              width: "60px",
              height: "60px",
              position: "absolute",
              left: "0",
              bottom: "0",
              right: "0",
              top: "0",
              margin: "auto",
            }}
            Loaded={isMount}
          />
        </div>

        <div className='h-98 p-8 bg-[#333333] rounded-bl-8 rounded-br-8 flex flex-col'>
          <p className='text-16 text-[#fff] leading-24 text-left line-clamp-2 mb-8 h-44'>{data.title}</p>
          <div className='flex items-center justify-between'>
            <p className='text-[#999999] text-16 leading-30'>{formatThousend(data.views || 0)}瀏覽</p>
            <div className='flex justify-center items-center'>
              <LikeOutlined style={{ fontSize: "16px", color: "#999999" }} />
              {data.likes != 0 && <span className='text-[#999999] text-16 leading-30 ml-6'>{data.likes}</span>}
            </div>
          </div>
        </div>
      </a>
    </section>
  );
};
export default MoviesShort;
